import {
  AnalyticsSiteAssets,
  DataLayerAnalytics,
  setAdobeAnalytics
} from '@com-delta-idp/mnx-skymiles-landing-page-ui';
import { SummaryAnalyticsEvent } from '@com-delta-idp/mnx-skymiles-shared';
import { USER_LOGGED_IN_STATUS } from '../models';
import {
  BannerClickEvent,
  BannerClickEventData
} from '../models/analytics/banner-click.interfaces';
import { getPageLoadTime } from './analytics.utils';

export const setupBannerClickListeners = (): void => {
  const events = [
    'micro_moment_click',
    'fast_action_banner_click',
    'upgrade_card_click',
    'skyclub spend tracker terms click',
    'Search eligible Sky Clubs',
    'upgrade_view_all',
    'tooltip'
  ];

  events.forEach((eventName) => {
    document.addEventListener(eventName, (event: Event) => {
      const bannerEvent = event as BannerClickEvent;
      handleBannerClick(eventName, bannerEvent.detail);
    });
  });
};

export const handleBannerClick = (
  clickName: string,
  eventData: string
): void => {
  const data: BannerClickEventData = JSON.parse(eventData);
  const selectedAsset = data.assets?.find((asset) => asset.id === data.id);

  const analyticsData: DataLayerAnalytics = {
    event_detail: data.eventName ? data.eventName : 'banner link click',
    event: 'click',
    user: {
      attributes: {
        is_logged_in: USER_LOGGED_IN_STATUS.AUTHENTICATED
      }
    },
    click: getClickProperties(clickName, data),
    site_assets: [selectedAsset]
  };

  setAdobeAnalytics(analyticsData);
};

const getClickProperties = (clickName: string, data: BannerClickEventData) => {
  return {
    name: clickName,
    type: 'link',
    page_section: data.pageSection ?? 'banner',
    page_subsection: '',
    action: data.link,
    component_name: data.component_name,
    component_type: data.component_type
  };
};

export const setLinkClickAnalytics = (
  data: SummaryAnalyticsEvent,
  assets: AnalyticsSiteAssets[]
): void => {
  const selectedAsset = assets.find((asset) => asset.id === data.id);
  const analyticsData: DataLayerAnalytics = {
    event_detail: data.eventType ?? 'click',
    event: data.event ?? 'click',
    click: {
      name: data.action?.label,
      type: 'link',
      page_section: 'skymiles overview tracker',
      action: data.action?.url
    },
    user: {
      attributes: {
        is_logged_in: 'authenticated'
      }
    },
    site_assets: data.id === 'millionmilerstatus' ? [selectedAsset] : undefined
  };
  setAdobeAnalytics(analyticsData);
};

export const updateSiteAssets = (
  analyticsData: DataLayerAnalytics,
  assets: AnalyticsSiteAssets[],
  pageLoadStart: number
): void => {
  const updatedAnalyticsData = {
    ...analyticsData,
    page: {
      info: {
        ...analyticsData.page.info,
        page_load_time: getPageLoadTime(pageLoadStart)
      }
    },
    site_assets: assets
  };
  const analyticsDataWithAssets = { ...updatedAnalyticsData };
  delete analyticsDataWithAssets.error;
  setAdobeAnalytics(analyticsDataWithAssets);
};
